export default __webpack_public_path__ + "6835bc8c5f9ae7ae6285687ce68add5e.png";